import { dayKey, todayKey } from "@/lib/time";

export const IN_PROGRESS = ["Driver En Route", "Arrived", "Passenger On Board", "In Progress"];
export const isInProgress = (s) => IN_PROGRESS.includes(s);
export const SET_STATUSES = ["Unassigned", "Assigned", "Will Call", "On Hold", "Completed", "Cancelled", "No Show"];
export const CLOSE_STATUSES = ["Completed", "No Show", "Cancelled"];

// [value, label, server status param]. One entry per status, named the way the office talks about it.
export const STATUS_FILTERS = [
  ["", "All statuses", ""],
  ["not_cancelled", "Not cancelled", "not_cancelled"],
  ["Unassigned", "Scheduled · no driver yet", "Unassigned"],
  ["Assigned", "Pending · assigned, not started", "Assigned"],
  ["Will Call", "Will Call", "Will Call"],
  ["in_progress", "In progress", "in_progress"],
  ["Completed", "Finalized · completed", "Completed"],
  ["Cancelled", "Cancelled", "Cancelled"],
  ["No Show", "No Show", "No Show"],
  ["On Hold", "On Hold", "On Hold"],
];
export const statusParam = (v) => (STATUS_FILTERS.find((f) => f[0] === v) || [])[2] || "";

export const isEarlierDay = (t) => !!t?.scheduled_pickup && dayKey(t.scheduled_pickup) < todayKey();
export const WILL_CALL_WAIT_MIN = 30;
export const willCallWaitMin = (t) => (t?.status === "Will Call" && t.will_call_ready_at && !t.assigned_driver_id && !t.assigned_driver_name
  ? Math.floor((Date.now() - new Date(t.will_call_ready_at).getTime()) / 60000) : null);
